//フロント側設定値
export const mapDistance =  0.03; // 3km
export const cookieMaxAge =  864000; // 10day
export const myAreaDisplayPeriod =  10; // 10day

//バックエンド側設定値
export const permittedRadius =  0.0003; // 30m：Makerをタッチした時にダイアログを表示させるために設定